export default __webpack_public_path__ + "static/media/1.38fe3a09.png";